export enum PopupType {
  unset = "",
  DailyReward = "DailyReward",
  Logout = "Logout",
  AddHomeScreen = "AddHomeScreen",
  PurchaseInventory = "PurchaseInventory",
  PurchaseResult = "PurchaseResult",
  OutOfGems = "OutOfGems",
  GameLose = "GameLose",
  QuitGame = "QuitGame",
  AndroidAddPwa = "AndroidAddPwa",
}

export enum PopupPriority {
  lowest = -1,
  unset = 0,
  low = 1,
  medium = 2,
  high = 3,
}

export const popupWithPriority: {
  [key: string]: PopupPriority;
} = {
  [PopupType.unset]: PopupPriority.unset,
  [PopupType.DailyReward]: PopupPriority.low,
  [PopupType.Logout]: PopupPriority.unset,
  [PopupType.PurchaseInventory]: PopupPriority.unset,
  [PopupType.PurchaseResult]: PopupPriority.unset,
  [PopupType.OutOfGems]: PopupPriority.unset,
  [PopupType.AddHomeScreen]: PopupPriority.unset,
  [PopupType.GameLose]: PopupPriority.unset,
  [PopupType.QuitGame]: PopupPriority.unset,
};
